import styled from 'styled-components'

export const StyledNewsCategoriesSelect = styled.div``
